import Grid from '@mui/material/Grid';
import "./style.css";
import React from 'react';
import {useState, useEffect} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography'
import NewCompanyPopUp from '../NewCompanyPopUp';
import {useNavigate} from "react-router-dom";

  const RedButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: "#ff0000",
    '&:hover': {
      backgroundColor: "#8b0000",
    },
  }));

  export default function ListCompanyExisting({handleClose, selectedPost,connectClose, handleCloseNoTelp,handleCloseNewCompany,selectNamaPerusahaan, setcompanyID, companies, handleCompany2, setCompanies, handleClosePreview,closechangePerusahaanPopUPOpen, setContractData, contractData}){

    
    const [skip, setSkip] = useState(0)
    const [isEnd,setIsEnd] = useState("loading..")
    const [posts, setPosts] = useState([])
    const [query, setQuery] = useState('');
    const [batas,setBatas] = useState("No");

   
    
    useEffect(() => {
        fetchPosts();
    }, [skip,query]);
  

    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }
     

    const fetchPosts = async () => {
        console.log("feeeetchiiing")
      if(query.trim()){
              try{
                  const { data, error } = await read(skip,query,batas);
                  if(error){
                      console.log(error.message);
                      return;
                  }
      
                  if(data?.length === 0){
                      setIsEnd("Selesai...");
                      return;
                  }
                  
                  //success
                  setPosts([...posts, ...data])
              }catch(error){
                  console.log(error.message);
              }
          
      }else{
  
      try{
          const { data, error } = await readEmpty(skip,query,batas);
          if(error){
              console.log(error.message);
              return;
          }
  
          if(data?.length === 0){
              setIsEnd("Selesai...");
              return;
          }
          
          //success
          setPosts([...posts, ...data])
      }catch(error){
          console.log(error.message);
      } 
      }
  }  

  const newFetchPosts = async (event) => {
    setPosts([])
    setIsEnd("Loading...");
    if(event.target.value.trim()){
    try{
        const { data, error } = await read(skip,event.target.value);
        if(error){
            console.log(error.message);
            return;
        }
  
        if(data?.length === 0){
            setIsEnd("Selesai...");
            return;
        }
        
        //success
        setPosts([...data])
    }catch(error){
        console.log(error.message);
    }
    }else{
        console.log("empty")
        try{
            const { data, error } = await readEmpty(skip,event.target.value);
            if(error){
                console.log(error.message);
                return;
            }
  
            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
    }
  }

    const selectedCompany = (event) => {
        console.log(event.target.value)
    }
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;
    
        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
      }
      const [openNewCompany, setOpenNewCompany] = useState(false);

      const newCompany = () => {
        console.log("here")
        setOpenNewCompany(true);
    };
  
    const navigate = useNavigate();

    const handleClicksss = (post) => {
        try {
            const idid = post._id;
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/latestKontrakNum`)
            .then(response => {
              console.log(response.data);
              console.log(response.data.jumlah);
              var testestest = response.data.jumlah;
              console.log(testestest);
              var piAmountNow = parseInt(testestest) + 1;
              console.log(piAmountNow);
              var tanggalAwal = new Date(selectedPost.TanggalMulai)
              var piMonth = new Date(tanggalAwal).getMonth() + 1
              var piYear = new Date(tanggalAwal).getYear() + 1900
              var piDate = new Date(tanggalAwal).getDate()
              var PINumbnow = piYear + "." + piMonth + "-Kontrak-Zanio." + piAmountNow;
              console.log({ PINumbnow, piAmountNow });
          
              return axios.post(`${process.env.REACT_APP_BACKEND_URL}/saveTempToKontrakVO`, {
              piAmountNow, PINumbnow, selectedPost, idid, namaPerusahaan:post.namaPerusahaan, tipePerusahaan:post.tipePerusahaan, industri:post.industri, npwp:post.npwp, noNib:post.noNib, akte:post.akte, company:post
              })
              .then(response => {
                console.log(response.data._id)
                const kontrakid = response.data._id; // extract _id from response
                console.log("Ini PINUMBNOW yang mau di render "+PINumbnow)
                return axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`, {
                  id: kontrakid // include _id here
                }, {
                  responseType: "blob"
                });
              })
              .then(resp => {
                console.log(resp)
                const blob = new Blob([resp.data], { type: 'application/pdf' })
                var fileURLNew = URL.createObjectURL(blob);
                console.log(fileURLNew)
                window.open(fileURLNew, '_blank');
                navigate("/")
              });
            }).catch(error => {
              console.error(error);
            });
        } catch (error) {
          console.log(error)
        }
      }

    return <Grid container>
    <Dialog open={openNewCompany} onClose={handleCloseNewCompany}>
        <NewCompanyPopUp selectedPost={selectedPost} handleClosePreview={handleClosePreview} connectClose={connectClose}></NewCompanyPopUp>
    </Dialog>
    <Grid container align = "center" justify = "center" alignItems = "center" sx={{pt:5, px:2, pb:2}}>
    <Typography sx={{mt:1, mb:3}}>Dibawah adalah daftar semua perusahaan yang pernah tersimpan di Zanio. Untuk perusahaan baru tekan "New+"</Typography>

                          <Grid sx={{mb:2}}>
                                <Button onClick={newCompany}>New +</Button>
                                <TextField
                                    value={query}
                                    onChange={handleSearch}
                                    placeholder="Search..."
                                />
                          </Grid>
                          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                              <TableContainer sx={{ maxHeight: 400, minHeight: 350 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                  <Table stickyHeader aria-label="sticky table">
                                      <TableHead>
                                          <TableRow>
                                              <TableCell>
                                                  Nama Company
                                              </TableCell>
                                          </TableRow>
                                      </TableHead>
                                      {posts?.map((post) => (
                                          <TableBody>
                                              <TableRow key={`${post.id}`}
                                                    hover
                                                    onClick={() => handleClicksss(post)}>
                                                  <TableCell style={{cursor:'pointer'}}>
                                                      <p>{post.namaPerusahaan}</p>
                                                  </TableCell>
                                              </TableRow>
                                          </TableBody>
                                      
                                      ))}
                                      {isEnd}
                                  </Table>
                              </TableContainer>
                          </Paper>
                              
                          </Grid>
  </Grid>};